/*
 * File: c:\Users\j.mazat\Desktop\Autobuy\AutobuyBackOffice\src\Services\Message\MessageService.ts
 * Project: c:\Users\j.mazat\Desktop\Autobuy\AutobuyBackOffice
 * Created Date: Wednesday August 2nd 2023
 * Author: Jonathan Mazat
 * -----
 * Last Modified: Friday, 22nd September 2023 01:52:56
 * Modified By: Simon (s.gourlet@autobuy.fr>)
 * -----
 * Copyright (c) 2023 Autobuy SAS
 * -----
 */

import Config from "Config/Config";
import { MessageTypeToCreate } from "Type/message.type";
import { buildAxiosHeader } from "Utils/Request.utils";
import Axios from "axios";

class MessageService {
    static async sendMessage(messageId: string, messageContent: string, usersEmail: string[], all?: boolean) {
        const myUrl = `${Config.BACKEND.BASEURL}${Config.BACKEND.PATHS.SENDMESSAGES}`;
        const body = all ? { id: messageId, all: true } : { id: messageId, content: messageContent, usersEmail: usersEmail };
        const myRet = await Axios.post(myUrl, body, buildAxiosHeader());
        return myRet.data;
    }

    static async CreateMessage(data: MessageTypeToCreate ) {
        const myUrl = `${Config.BACKEND.BASEURL}${Config.BACKEND.PATHS.MESSAGES}`;
        const myRet = await Axios.post(myUrl, data, buildAxiosHeader());
        return myRet.data;
    }

    // static async getOneMessage(messageID: string) {
    //     const myUrl = `${Config.BACKEND.BASEURL}${Config.BACKEND.PATHS.MESSAGES}/${messageID}`;
    //     const myPartners = await Axios.get(myUrl, buildAxiosHeader());
    //     return myPartners.data;
    // }

    static async getAllMessages() {
        const myUrl = `${Config.BACKEND.BASEURL}${Config.BACKEND.PATHS.MESSAGES}`;
        const myMessages = await Axios.get(myUrl, buildAxiosHeader());
        return myMessages.data;
    }

    static async UpdateMessage(messageID: string, Content: string ) {
        const myUrl = `${Config.BACKEND.BASEURL}${Config.BACKEND.PATHS.MESSAGES}/${messageID}`;
        const myRet = await Axios.put(myUrl, {Content}, buildAxiosHeader());
        return myRet;
    }

    static async DeleteMessage(messageID: string) {
        const myUrl = `${Config.BACKEND.BASEURL}${Config.BACKEND.PATHS.MESSAGES}/${messageID}`;
        try {
            const myRet = await Axios.delete(myUrl, buildAxiosHeader());
            return myRet.data;
        } catch (error: any) {
            return error.request.status;
        }
    }
}

export default  MessageService;
